import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken } from "../auth";

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_AWS_API_GATEWAY_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getToken(); 
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
        headers.set("withCredentials", false);
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
});
